import Link from "next/link";
import Image from "@/components/image";

export default function Angled({ fields, first = false, sys, includes }) {
  const titleParts = fields.title && fields.title.split(" ");
  const last = titleParts.pop();
  const Title = ({ children }) => {
    return first ? (
      <h1 className="text-3xl leading-relaxed text-gray-900 font-semibold sm:text-5xl md:text-6xl">
        {children}
      </h1>
    ) : (
      <h3 className="text-3xl leading-relaxed text-gray-900 font-semibold sm:text-5xl md:text-6xl">
        {children}
      </h3>
    );
  };
  return (
    <section className="relative bg-white overflow-hidden flex flex-col">
      <div className="order-2 lg:order-1 relative z-10 pb-8 h-full bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:max-w-3xl xl:pb-32">
        <svg
          className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
          fill="currentColor"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <polygon points="50,0 100,0 50,100 0,100" />
        </svg>
        <section className="mt-4 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-20 lg:px-8 xl:mt-28">
          <div className="sm:text-center lg:text-left">
            {fields.title && (
              <Title>
                <span className="xl:inline">{titleParts.join(" ")}</span>
                {last && (
                  <span className="text-brand-500 xl:inline"> {last}</span>
                )}
              </Title>
            )}
            {fields.text && (
              <p className="my-8 text-xl text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                {fields.text}
              </p>
            )}
            <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
              {fields.actions &&
                fields.actions.map((action, index) => (
                  <div
                    className={`rounded-md shadow ${
                      index !== 0 ? "mt-4 md:mt-0 md:ml-4" : ""
                    }`}
                    key={`${action.sys.id}-${index}`}
                  >
                    <Link
                      href={action.fields.link}
                      className={`w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-sans rounded-md ${
                        index === 0
                          ? "text-white bg-brand-600 hover:bg-brand-700"
                          : "text-brand-500-700 bg-brand-100 hover:bg-brand-200"
                      } md:py-4 md:text-lg md:px-10`}
                    >
                      {action.fields.text}
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </section>
      </div>
      {/*  */}
      <div className="order-1 relative pb-64 md:pb-96 lg:pb-0 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        {fields.image && (
          <Image
            alt=""
            fill
            fields={fields.image}
            className="w-full lg:object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
          />
        )}
      </div>
    </section>
  );
}
